import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

import { Link } from "react-router-dom";
import { useModelIndex } from "@rhino-project/core/hooks";
import { asHandoff, listResults } from "../lib/thirdDoorAdapters";

export default function NavigatorDashboard() {
  const { resources } = useModelIndex("handoff_event" as any, { limit: 25 } as any);
  const files = listResults(resources).map(asHandoff);
  return (
    <div className="w-full min-w-0 bg-background text-foreground overflow-x-hidden">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
          <section className="w-full space-y-6">
      <Card className="border-primary/20 shadow-sm">
      <CardHeader>
      <Badge className="w-fit">Navigator Role</Badge>
      <CardTitle className="text-2xl">Manage files and coordinate warm handoffs</CardTitle>
      <CardDescription>Track assigned files, route readiness tasks, and coordinate sponsor-facing transitions.</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-3">
      <Button asChild><Link to="/navigator-role/my-files">My Files</Link></Button>
      <Button asChild variant="outline"><Link to="/navigator-role/file-detail">Open File Detail</Link></Button>
      </CardContent>
      </Card>

      <div className="grid gap-4 md:grid-cols-4">
      {[
      { label: "Assigned files", value: String(files.length) },
      { label: "Active handoffs", value: String(files.filter((file) => file.status !== "Completed").length) },
      { label: "Awaiting sponsor input", value: String(files.filter((file) => /sponsor/i.test(file.next_action || file.action)).length) },
      { label: "Escalations", value: String(files.filter((file) => /escal/i.test(file.status)).length) },
      ].map((metric) => (
      <Card key={metric.label} className="border-border shadow-sm">
      <CardHeader className="pb-2">
      <CardDescription>{metric.label}</CardDescription>
      <CardTitle>{metric.value}</CardTitle>
      </CardHeader>
      </Card>
      ))}
      </div>

      <Card className="border-border shadow-sm">
      <CardContent className="p-0">
      <div className="overflow-x-auto">
      <Table>
      <TableHeader>
      <TableRow>
      <TableHead>Company</TableHead>
      <TableHead>Pathway</TableHead>
      <TableHead>Status</TableHead>
      <TableHead>Next Action</TableHead>
      <TableHead>Updated</TableHead>
      </TableRow>
      </TableHeader>
      <TableBody>
      {files.map((row) => (
      <TableRow key={row.id}>
      <TableCell className="font-medium">{row.company}</TableCell>
      <TableCell>{row.route}</TableCell>
      <TableCell><Badge variant="secondary">{row.status}</Badge></TableCell>
      <TableCell>{row.next_action}</TableCell>
      <TableCell>{row.updated}</TableCell>
      </TableRow>
      ))}
      </TableBody>
      </Table>
      </div>
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}